module.exports = "https://99designs-start-assets.imgix.net/js/5da4cf4a2b7483a5a3967e31706ab588.png";